// extracted by mini-css-extract-plugin
export var active = "_32-7";
export var container = "_32-0";
export var evenWidth = "_32-4";
export var large = "_32-5";
export var outlet = "_32-8";
export var slide = "_32-2";
export var small = "_32-6";
export var tab = "_32-3";
export var tabs = "_32-1";